/**
 * app分享
 */

let defaultShareConfig = {}

/**
 * 初始化分享信息
 */
function initShareInput() {
  const inputs = `<input id="input-shareurl" type="hidden" name="tcshareurl" value="">
  <input id="input-shareimg" type="hidden" name="tcshareimg" value="">
  <input id="input-sharetitle" type="hidden" name="tcsharetext" value="">
  <input id="input-sharedesc" type="hidden" name="tcDesc" value=""></input>`
  $('body').append(inputs)
}
initShareInput()

function randomString(length) {
  const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let result = '';
  for (let i = length; i > 0; --i) {
    result += str[Math.floor(Math.random() * str.length)];
  }
  return result;
}
/**
 * 更新dom
 */
function updateShareInput() {
  const { path, imageUrl, title, desc } = defaultShareConfig
  $('#input-shareurl').val(path)
  $('#input-shareimg').val(imageUrl)
  $('#input-sharetitle').val(title)
  $('#input-sharedesc').val(desc)
  if (window.Android) {
    Android.setTcshareurl && Android.setTcshareurl(path);//链接
    Android.setTcshareimg && Android.setTcshareimg(imageUrl);//图片
    Android.setTcsharetext && Android.setTcsharetext(title);//内容
    Android.setTcsharedesc && Android.setTcsharedesc(desc);//描述
  }
}
/**
 * 初始化分享
 */
export function initShare(shareConfig) {
  shareConfig.path = `https://m.ly.com/app/links/web/main_${randomString(18)}?url=${encodeURIComponent(shareConfig.path)}&wakeDU=1`;
  defaultShareConfig = shareConfig;
  // 更新
  updateShareInput();
}
/**
 * 调用分享
 * @param {Record<string, any} shareConfig 分享配置
 * @returns {Promise<Record<string, any>} 返回对象
 */
export function share(shareConfig) {
  // 修改默认配置
  if (shareConfig) defaultShareConfig = shareConfig
  // 获取信息
  const { path, imageUrl, title, desc } = defaultShareConfig
  return new Promise((resolve, reject) => {
    _tc_bridge_bar.shareInfoFromH5({
      param: {
        "tcsharetxt": title,
        "tcsharedesc": desc || title,
        "tcshareurl": path,
        "tcshareimg": imageUrl,
        "hideToast": "1",// 0 默认显示|1 隐藏Toast
        "shareType": "haoyou",//742添加，tcsharetype=true时，pengyouquan:朋友圈(默认)|haoyou：好友；10.03添加当tcsharetype="false"时 haoyou|pengyouquan|weixinFav|qq|qzone
        "tcsharetype": true
      },
      callback(data) {
          const cbObj = JSON.parse(data.cbObj)
          const { status } = cbObj
          // 分享成功
          resolve(cbObj)
      }
    })
  })
}